<div *ngIf="isLoading$ | async as isLoading">
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="loading-spinner">
      <div class="spinner-border text-primary" role="status" aria-live="polite" aria-busy="true">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>